import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          cursor: pointer;\n\n          &:hover {\n            background-color: ", ";\n          }\n\n          &:hover,\n          &:focus {\n            color: ", ";\n            text-decoration: none;\n          }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          pointer-events: none;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-sizing: border-box;\n  color: ", ";\n  display: block;\n  text-decoration: none;\n  transition: background-color ", ";\n  width: 100%;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React from 'react';
import styled, { css } from 'styled-components';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { color, property } from '@scp/ui-shared/theme/variables';
import { LinkOrButton } from './LinkOrButton';
import { withoutProps } from '@scp/ui-shared/core/hoc';
var LinkComponent = withRippleEffect(withoutProps(LinkOrButton, ['isActive']));
var RowLinkOrButton = styled(LinkComponent)(_templateObject(), function (props) {
  return props.isActive ? color.active : color.background;
}, color.textPrimary, property.transition, function (props) {
  return props.disabled ? css(_templateObject2()) : css(_templateObject3(), props.isActive ? color.active : color.backgroundSecondary, color.textPrimary);
});
/**
 * A ClickableRow component that adds styling to the LinkOrButton component by adding
 * hover and isActive states to the component.
 *
 * @example ./__docs__/ClickableRow.md
 */

export function ClickableRow(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$isActive = _a.isActive,
      isActive = _a$isActive === void 0 ? false : _a$isActive,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      dataE2e = _a.dataE2e,
      props = __rest(_a, ["children", "isActive", "disabled", "dataE2e"]);

  var shouldRenderAsDiv = disabled;
  var adjustedProps = shouldRenderAsDiv ? Object.assign(Object.assign({}, props), {
    'data-e2e': dataE2e
  }) : Object.assign(Object.assign({}, props), {
    dataE2e: dataE2e
  });
  return React.createElement(RowLinkOrButton, Object.assign({
    isActive: isActive,
    as: shouldRenderAsDiv ? 'div' : LinkComponent,
    disabled: disabled
  }, adjustedProps), children);
}